import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Header from './header';


const styles = {
  div: {
    display: 'flex',
    flexDirection: 'row wrap',
    padding: 0,
    width: '100%',
  },
  pageWrapper: {
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    overflow: 'hidden',
  },
  messageArea: {
    height: '900px',
    position: 'relative',
    zIndex: '1',
    backgroundPosition: 'bottom center',
    backgroundSize: 'cover',
    background: 'linear-gradient( 90deg, #334956 0%, #334956 100%)',
    clipPath: 'ellipse(100% 85% at 12% 13%)',
  },
  clearfix: {
    display: 'block',
    clear: 'both',
    content: '',
  },
  messageContainer: {
    textAlign: 'center',
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    color: '#fff',
  },
  mainWarning: {
    paddingTop: '30vh',
    paddingBottom: '2%',
    fontSize: '3em',
    fontWeight: '800',
    margin: '0',
    '&::before, &::after': {
      content: '"!"',
      display: 'inline-block',
      height: '1em',
      width: '1em',
      borderRadius: '0.25em',
      backgroundColor: '#b61402',
      margin: '0 0.25em',
    },
  },
  secondaryWarning: {
    width: '60%',
  },
};

const UnauthorizedPage = ({
  domain,
  clientID,
  redirectURI,
  authServer,
  error,
  classes,
}) => (
  <div className={classes.pageWrapper}>
    <Header {...{
      domain,
      clientID,
      redirectURI,
      authServer,
    }}
    />
    <section
      className={classNames(
        classes.messageContainer,
        classes.messageArea,
        classes.clearfix,
      )}
    >
      <h3 className={classes.mainWarning}>
        User not authorized
      </h3>
      <p className={classes.secondaryWarning}>
        {error && `${error} `}
Please contact a system administrator for access to the portal.
      </p>
    </section>
  </div>
);


export default withStyles(styles)(UnauthorizedPage);
